<template>
  <div class="">
    <div class="bg-white padding" style="position: relative; z-index: 2; padding-top: 24pt" ref="card" v-show="waterNumberList.length>0">
      <div class="input-item" style="justify-content: space-between">
        <div style="display: flex">
          <div class="line"></div>
          <span class="text-nowrap">常用水號</span>
        </div>
        <div style="float: right; font-size: 16px" class="text-blue" @click="changeModifyListStatus">{{ isListInModify ? '完成' : '編輯' }}</div>
      </div>
      <div class="dark-card">
        <div v-for="item in waterNumberList" :key="item.number" class="flex">
          <div>{{ formatSpace(item.water_number) }}</div>
          <div class="delete" @click="removeWaterNumber(item.water_number_serial_number)" v-if="isListInModify"></div>
          <div class="active" @click="getBillIsNull(item.water_number)" v-else>查詢</div>
        </div>
      </div>
    </div>
    <div class="padding bg-white">
      <div>
        <div class="input-item text-nowrap">
          <div class="line"></div>
          {{ waterNumberList.length>0 ? '查詢其他水號' : '請輸入水號' }}
        </div>
        <div class="input-item-more">站所2碼＋編號8碼＋檢號1碼</div>
        <input type="text" name="waterNumber" placeholder="00 00000000 0" class="input" v-model="waterNumber" @focus="focusInput" @blur="blurInput" />
        <div class="border-bottom" :style="waterNumberBorderStyle"></div>
        <div class="agree-label" style="margin-bottom: 16pt">
          <input type="checkbox" id="isAddFavoriteChecked" v-model="isAddFavoriteChecked" />
          <label for="isAddFavoriteChecked">加入常用水號</label>
        </div>
        <button class="btn btn-primary" :disabled="isDisabled" @click="addFavoriteWaterNumber">查詢待繳帳單</button>
      </div>
    </div>
    <div class="padding description">
      <ul class="text-gray2">
        <li>如已設定水費自動扣款或已在其他代收單位繳費，請勿重複繳費。</li>
        <li>可使用悠遊付錢包、銀行帳戶連結、信用卡(<span class="text-blue">限台新銀行、玉山銀行發卡</span>)進行繳費扣款。</li>
        <li>繳費後無法取消，如需退費或有疑問，請洽24小時客服專線<a href="tel:1910" class="text-blue text-underline">1910</a> (台北市市話請改撥<a href="tel:0289780837" class="text-blue text-underline">02-89780837</a>)。</li>
        <li>10分鐘內未完成繳費，請重新查詢。</li>
      </ul>
    </div>
    <div :class="isListInModify ? 'mask' : ''" ref="mask"></div>
  </div>
</template>

<script>
import { saveFavoriteTaiwanWaterNumber, queryFavoriteTaiwanWaterNumber, deleteFavoriteTaiwanWaterNumber, queryBillList } from '../../api/api';

export default {
  name: 'taiwan-water-fee',
  data() {
    return {
      waterNumberList: [],
      isListInModify: false,
      isAddFavoriteChecked: true,
      waterNumber: '',
      waterNumberInFocus: false,
    };
  },
  created() {
    this.getFavoriteWaterNumber();
  },
  computed: {
    isDisabled() {
      return this.waterNumber === '';
    },
    waterNumberBorderStyle() {
      return this.waterNumberInFocus ? 'background: #007ac8' : 'background: #c7c7c7';
    },
  },
  methods: {
    getFavoriteWaterNumber() {
      queryFavoriteTaiwanWaterNumber().then((res) => {
        if (res.error == null) {
          this.waterNumberList = res.water_number_list;
          setTimeout(() => {
            var height = this.$refs.card.clientHeight;
            this.$refs.mask.style.top = height + 'px';
          }, 1000);
        }
      });
    },
    addFavoriteWaterNumber() {
      if (this.isAddFavoriteChecked) {
        saveFavoriteTaiwanWaterNumber({ water_number: this.clearSpace(this.waterNumber) }).then((res) => {
          if (res.error != null) {
            if (res.error.code === '20000') {
              alert('水號不正確！請確認後再重新查詢。');
            } else {
              alert(res.error.message);
            }
          } else {
            this.getFavoriteWaterNumber();
            this.getBillIsNull(this.waterNumber);
          }
        });
      } else {
        this.getBillIsNull(this.waterNumber);
      }
    },
    searchBill(waterNumber) {
      this.$router.push({
        path: '/goPay',
        query: { payment_item_id: 'TWNCH-0103', parameter1: this.clearSpace(waterNumber), payment_query_type: "REALTIME-1" },
      });
    },
    getBillIsNull(waterNumber) {
      var form = {
        payment_item_id: 'TWNCH-0103',
        payment_query_type: 'REALTIME-1',
        parameter1: this.clearSpace(waterNumber),
        parameter2: '',
        parameter3: '',
        payment_custom_id: '',
      };
      queryBillList(form).then((res) => {
        if (res.error === undefined) {
          this.searchBill(waterNumber);
        } else {
          alert(res.error.message);
        }
      });
    },
    changeModifyListStatus() {
      this.isListInModify = !this.isListInModify;
    },
    removeWaterNumber(waterNumberSerialNumber) {
      if (confirm('確定要刪除？')) {
        deleteFavoriteTaiwanWaterNumber({ water_number_serial_number: waterNumberSerialNumber }).then((res) => {
          if (res.error == null) {
            this.isListInModify = false;
            this.getFavoriteWaterNumber();
          } else {
            alert(res.error.message);
          }
        });
      }
    },
    formatSpace(waterNumber) {
      if (waterNumber.length) {
        //if (waterNumber.length < 10) {
          //waterNumber = waterNumber.padEnd(10, '0');
        //}
        return waterNumber.slice(0, 2) + ' ' + waterNumber.slice(2, 10) + ' ' + waterNumber.slice(10, 11);
      }
    },
    clearSpace(waterNumber) {
      return waterNumber.replace(/\s+/g, '');
    },
    blurInput() {
      this.waterNumber = this.formatSpace(this.waterNumber);
      this.waterNumberInFocus = false;
    },
    focusInput() {
      this.waterNumber = this.clearSpace(this.waterNumber);
      this.waterNumberInFocus = true;
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9pt 0;
  border-bottom: 1px solid rgba(64, 64, 64, 0.75);
}
</style>
